import { render, staticRenderFns } from "./ReportRoadsImages.vue?vue&type=template&id=2f59f9de&scoped=true&"
import script from "./ReportRoadsImages.vue?vue&type=script&lang=js&"
export * from "./ReportRoadsImages.vue?vue&type=script&lang=js&"
import style0 from "./ReportRoadsImages.vue?vue&type=style&index=0&id=2f59f9de&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f59f9de",
  null
  
)

export default component.exports
import {QIcon,QTooltip,QBtn,QBanner} from 'quasar'
component.options.components = Object.assign({QIcon,QTooltip,QBtn,QBanner}, component.options.components || {})
